export enum OperacaoPgtoEnum {
    Venda = 1, PagamentoCrediario = 2, Desconto = 3, Juros = 4, TaxaServico = 5, Suprimento = 6, Sangria = 7, ContasReceberAvulso = 8, CreditoDevolucao = 9, SemPagamentoNFe = 10
}
